import ElementTagNames from '../../constants/ElementTagNames';
import ClassNames from '../../constants/ClassNames';

export default class ErrorMessage {
  class: string;
  message: string;
  element: HTMLElement;

  /**
   *
   */
  constructor(message: string) {
    this.class = ClassNames.ERROR_MESSAGE;
    this.message = message;
    this.element = this.create();
  }

  /**
   * Create an error message
   */
  create(): HTMLElement {
    const element: HTMLElement = document.createElement(ElementTagNames.PARAGRAPH);
    element.className = this.class;
    element.innerText = this.message;
    return element;
  }
}
